const apiUrl = process.env.REACT_APP_API_URL;
export const GetEmpresas = async (id: number, page : string) => {
    try{
        const response = await fetch(`${apiUrl}:8074/admin/empresas/${id}`,{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla':page
            }

        });
        const jsonData = await response.json();
        return jsonData;
    }catch (error){
        console.log('Error al obtener los datos', error);
    }
};